var map = {
	"./1.png": "UEeO",
	"./1688-unselect.png": "p9+y",
	"./1688.png": "wNpL",
	"./2.png": "Jq7T",
	"./3.png": "bnJM",
	"./4.png": "DUXn",
	"./800+.png": "dgH0",
	"./Farfetch-unselect.png": "F8cN",
	"./Farfetch.png": "cMRu",
	"./LOGO.png": "gvMp",
	"./Microsoft-unselect.png": "FFox",
	"./Microsoft.png": "t0wD",
	"./aiqiyi-unselect.png": "qKV2",
	"./aiqiyi.png": "pO/e",
	"./apple-unselect.png": "haFx",
	"./apple.png": "hK6O",
	"./arrow.png": "d2eT",
	"./banner.png": "bf9R",
	"./huawei-unselect.png": "2FEe",
	"./huawei.png": "Oq0i",
	"./icon1.png": "9RAP",
	"./icon2.png": "D64e",
	"./icon3.png": "WMpv",
	"./jingdong-unselect.png": "bV9l",
	"./jingdong.png": "6HPF",
	"./line.png": "mrWz",
	"./meidi-unselect.png": "/L2b",
	"./meidi.png": "wfzB",
	"./meituan-unselect.png": "PVZq",
	"./meituan.png": "S77p",
	"./nike-unselect.png": "L9MH",
	"./nike.png": "24ar",
	"./weipinhui-unselect.png": "A4np",
	"./weipinhui.png": "g+V1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xg36";